module.exports = __webpack_public_path__ + "media/images/clients/payoo_logo-424e86d2938684a6a1d7daac34b89d09.png";